import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchAuthSession } from '@aws-amplify/auth';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { decodeJWT } from '@aws-amplify/auth';

const UserContext = createContext();

export const getFreshAccessToken = async () => {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.accessToken?.toString();
  } catch (err) {
    console.error('[getFreshAccessToken] ❌ Impossible de récupérer un token valide :', err);
    return null;
  }
};

export const UserProvider = ({ children }) => {
  const { user } = useAuthenticator((context) => [context.user]);
  const [tokens, setTokens] = useState({ idToken: null, accessToken: null });
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const loadTokens = async () => {
      try {
        if (!user) return;

        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();
        const accessToken = session.tokens?.accessToken?.toString();

        if (idToken && accessToken) {
          setTokens({ idToken, accessToken });
          sessionStorage.setItem('idToken', idToken);
          sessionStorage.setItem('accessToken', accessToken);

          const decoded = decodeJWT(idToken);
          const payload = decoded.payload;

          //console.log('[UserContext] Contenu décodé du idToken :', decoded);
          //console.log('[UserContext] Contenu dpayload:', payload);

          // ➕ Récupération des groupes Cognito (peut être array ou string)
          let groupsRaw = payload['cognito:groups'] ?? [];
          if (typeof groupsRaw === 'string') {
            groupsRaw = groupsRaw.split(',').map((g) => g.trim()).filter(Boolean);
          }
          const groups = Array.isArray(groupsRaw) ? groupsRaw : [];
          const isAdmin = groups.includes('Admin');

          // Détection du provider
          let provider = 'Cognito';
          let displayName = user.username;

          if (payload.identities && payload.identities.length > 0) {
            const identity = payload.identities[0];
            if (identity.providerName === 'Google') {
              provider = 'CognitoGoogle';
              displayName = payload.given_name || user.username;
            }
          }
          
          setUserInfo({
            username: user.username,
            email: payload.email || '',
            displayName,
            provider,
            // ➕ exposer les groupes et le flag admin
            groups,
            isAdmin,
          });
          console.log('[UserContext] Utilisateur connecté :', {  groups, isAdmin, provider });
        } else {
          console.warn('[UserContext] Tokens manquants dans la session');
        }
      } catch (err) {
        console.error('[UserContext] Erreur lors de fetchAuthSession :', err);
      }
    };

    loadTokens();
  }, [user]);

  return (
    <UserContext.Provider value={{ userInfo, tokens }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);
